import moment from 'moment/moment'
import dateTimeCurrent from './dateTimeCurrent'
import {
  FORMAT_DATE_MINIMUM_YEAR,
  VALIDATION_DOB_MSG_EMPTY,
  VALIDATION_DOB_MSG_INVALID
} from './constants'

export default function birthDateValidate(date) {
  const valid =
    moment(date).isAfter(FORMAT_DATE_MINIMUM_YEAR) &&
    moment(date).isBefore(dateTimeCurrent(), 'year')

  return !date ? VALIDATION_DOB_MSG_EMPTY : !valid ? VALIDATION_DOB_MSG_INVALID : undefined
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/birthDateValidate.js